import {createHelpers} from 'vuex-map-fields';
import {errorOutput} from "../../helpers/errorOutput";
import {__t} from "../../helpers/translate";
import {PromiseWorker} from "../../helpers/promiseWorker";
import {getErrorTextResponse} from "../../helpers/getErrorTextResponse";
import {useToast} from "vue-toastification";
import executePromises from "../../helpers/executePromises";
import {setStatesLoadingList} from "../../helpers/setStatesLoadingList";
import {sendEventsList} from "../../helpers/sendEventsList";

const toast = useToast();

const {getCouriersField, updateCouriersField} = createHelpers({
    getterType: 'getCouriersField',
    mutationType: 'updateCouriersField',
});

const state = {
    search_order: {
        loading: false,
        uniq_id: null,
        need_select_pos: false,
        delivery_locations: [],
        delivery_restaurants: [],
        order: {
            is_exist: false,
            is_delivery: false,
        }
    },

    orderInfoByLocation: {
        loading: false,
        selectLocation: null,
        order: {}
    },
    makeOrderInfo: {
        loading: false,
        is_ok: false,
        order: {},
    },
    countAllCouriers: 0,
    isNewCourier: false,
    isLoadLocationsDelivery: false,
    isLoadCourierStatus: false,
    isSelectCourierItem: false,
    couriersOrdersPooling: {
        loading: false,
        couriersNewList: [],
        couriersInProgressList: [],
        couriersReadyList: [],
    },
    activeCourierOrder: null,
    deliveryLocations: [],
    activeDeliveryLocationsId: [],
    activeCourierOrderInfo: {
        loadingInfo: false,
        order: {
            id: 0
        },
        status: '',
        loadingLogs: false,
        logs: [],
    },
    stateCancelActiveOrder: false,
    activeAggregator: null,
    couriersListGroups: [
        {id: 1, const: 'O.COURIER_ORDERS_LIST', type_data: '', isSelect: true},
        {id: 2, const: 'O.COURIER_ORDER_NEW', type_data: '', isSelect: false},
    ],
    activeItemListGroups: null,
    ordersPos: {
        data: [],
        loading: false,
    },
    selectLocationCourier: null,
    orderRestLocations: [],
    // ordersPos: [],
    // isLoadingOrderPos: false,
}
const actions = {

    STATE_LOAD_LOCATIONS_DELIVERY({commit}, stateLoad) {
        commit('stateLoadLocationsDelivery', stateLoad);
    },
    FETCH_ORDER({commit}, order_uniq_id) {
        $store.dispatch('couriers/ORDER_SEARCH_STATE', true);

        return new Promise((resolve, reject) => {
            $api
                .get('/internal/delivery/order/' + order_uniq_id)
                .then(({data}) => {
                    try {
                        $store.dispatch('couriers/FILL_ORDER_ID', order_uniq_id)
                        $store.dispatch('couriers/OPERATE_ORDER', data);
                        resolve(data.data);
                    } catch (e) {
                        errorOutput(__t('O.FAILED_TO_GET_INFORMATION'), {});
                        $store.dispatch('couriers/ORDER_SEARCH_STATE', false);
                        reject(e.message);
                    }
                })
                .catch(err => {
                    $store.dispatch('couriers/ORDER_SEARCH_STATE', false);
                    errorOutput(__t('O.FAILED_TO_GET_INFORMATION'), err);
                    reject('search_error');
                })
        });
    },

    async FETCH_ORDER_REST_LOCATIONS({commit}, params) {
        const requests = [];
        requests.push(
            {
                requestName: 'orderRestLocations',
                url: '/internal/delivery/order/{order_uniq_id}/rest_locations',
                paramsUrl: {
                    order_uniq_id: params.order_uniq_id,
                },
                method: 'GET',
                body: null,
            },
        )

        const props = {
            commit: commit,
            commitName: 'fetchOrderRestLocations',
            nameError: 'O.FAILED_FETCH_ORDER_RESTAURANT_AND_LOCATIONS',
            requests: requests,
            showError: true,
        }
        await executePromises(state, params, props);

    },

    SET_ACTIVE_AGGREGATOR({commit}, activeAggregator) {
        commit('setActiveAggregator', activeAggregator);
    },
    FILL_ORDER_ID({commit}, order_uniq_id) {
        commit('fillOrderId', order_uniq_id);
    },
    OPERATE_ORDER({commit}, data) {
        if (!data.status || data.status === 'operation_fail') {
            console.error('ERR_GET_ORDER', data);
            throw new Error(__t('O.REQUEST_ERR'));
        }

        let resp = data.data;
        let is_order_exist = false;
        let is_delivery = false;

        let go_location = resp.need_select_pos;


        // if (resp.hasOwnProperty('order')) {
        //     let order = resp.order;
        //     is_order_exist = order.is_exist;
        //     is_delivery = order.is_delivery;
        //
        //     if (is_order_exist && is_delivery || go_location) {
        commit('searchComplete', resp);
        //         return;
        //     }
        //
        //     if(!is_order_exist) {
        //         throw new Error(__t('O.ORDER_NOT_FOUND'));
        //     }
        //
        //     if (!is_delivery) {
        //         throw new Error(__t('O.ORDER_IS_NOT_DELIVERY'));
        //     }
        // }
    },

    ORDER_SEARCH_STATE({commit}, state) {
        commit('searchOrderLoading', state);
    },

    GET_COUNT_ALL_COURIERS({commit}, params) {
        commit('getCountAllCouriers', params)
    },

    CLICK_ITEM_MENU_COURIERS({commit}, itemMenu) {
        commit('clickItemMenuCouriers', itemMenu);
    },
    CLICK_ITEM_MENU_COURIERS_POS({commit}, itemMenu) {
        commit('clickItemMenuCouriersPos', itemMenu);
    },

    CHANGE_STATE_NEW_COURIER({commit}, stateCourier) {
        commit('changeStateNewCourier', stateCourier);
    },

    LOAD_STATUS_COURIER({commit}) {
        commit('loadStatusCourier');
    },

    STATE_LOAD_ORDERS_POOLING_DELIVERY({commit}, stateLoad) {
        commit('setLoadOrdersPoolingDelivery', stateLoad)
    },

    STATE_LOAD_COURIER_STATUS({commit}, stateLoad) {
        commit('setLoadCourierStatus', stateLoad);
    },

    STATE_SELECT_COURIER_ITEM({commit}, stateSelect) {
        commit('setIsSelectCourierItem', stateSelect);
    },
    SELECT_LOCATION_COURIER_NEW_REGISTRATION({commit}, location) {
        if (state.search_order.uniq_id === null) {
            errorOutput(__t('O.THE_ORDER_NUMBER_IS_NOT_SPECIFIED'), 'the order number is not specified');
            return;
        }
        $store.dispatch('couriers/ORDER_INFO_BY_LOCATION_STATE', true);
        $store.dispatch('couriers/ORDER_INFO_SELECT_LOCATION', location);
        return new Promise((resolve, reject) => {
            $api
                .get('/internal/delivery/locations/' + parseInt(location.id) + '/order/' + parseInt(state.search_order.uniq_id) + '/pos_build')
                .then(({data}) => {
                    try {
                        if (data.status === 'operation_success' && data.data) {
                            $store.dispatch('couriers/OPERATE_ORDER_INFO_BY_LOCATION', data.data);
                            resolve(data.data);
                            return;
                        }
                        reject(data);
                    } catch (e) {
                        console.log(e);
                        $store.dispatch('couriers/ORDER_INFO_BY_LOCATION_STATE', false);
                        errorOutput(__t('O.FAILED_TO_GET_INFORMATION_ORDER_BY_LOCATION'), e);
                        reject(e.message);
                    }
                })
                .catch(err => {
                    $store.dispatch('couriers/ORDER_INFO_BY_LOCATION_STATE', false);
                    errorOutput(__t('O.FAILED_TO_GET_INFORMATION_ORDER_BY_LOCATION'), err);
                    reject('search_error');
                })
        });
    },
    OPERATE_ORDER_INFO_BY_LOCATION({commit}, data) {
        if (!data.status || data.status === 'operation_fail') {
            $store.dispatch('couriers/ORDER_INFO_BY_LOCATION_STATE', false);
            console.error('ERR_GET_ORDER', data);
            throw new Error(__t('O.REQUEST_ERR'));
        }
        let resp = data.data;
        commit('getOrderInfoComplete', resp);
    },
    ORDER_INFO_BY_LOCATION_STATE({commit}, stateLoad) {
        commit('orderInfoByLocationLoading', stateLoad);
    },
    ORDER_INFO_SELECT_LOCATION({commit}, location) {
        commit('setOrderInfoSelectLocation', location);
    },
    MAKE_ORDER({commit}, orderInfo) {
        if (!state.orderInfoByLocation.selectLocation || !state.orderInfoByLocation.selectLocation.id) {
            $store.dispatch('couriers/CHANGE_MAKE_ORDER_STATE', false);
            errorOutput(__t('O.MAKE_ORDER_ERROR'), 'No locations for create order');
            return;
        }
        return new Promise((resolve, reject) => {
            $api
                .put('/internal/delivery/locations/' + parseInt(state.orderInfoByLocation.selectLocation.id) + '/order', orderInfo)
                .then(({data}) => {
                    $store.dispatch('couriers/CHANGE_MAKE_ORDER_STATE', false);
                    try {
                        if (data.status === 'operation_success' && data.data) {
                            $store.dispatch('couriers/MAKE_ORDER_OPERATE', data.data);
                            resolve(data.data);
                            return;
                        }
                        errorOutput(__t('O.MAKE_ORDER_ERROR'), data);
                        commit('makeOrderOperate', false);
                        reject(data);
                    } catch (e) {
                        errorOutput(__t('O.MAKE_ORDER_ERROR'), e);
                        commit('makeOrderOperate', false);
                        reject(e);
                    }
                })
                .catch(err => {
                    console.log(err);
                    commit('makeOrderOperate', false);
                    errorOutput(__t('O.MAKE_ORDER_ERROR'), err);
                    reject('search_error');
                })
        });

    },
    MAKE_ORDER_OPERATE({commit}, data) {
        if (!data.status || data.status === 'operation_fail' || (data.data && !data.data.is_ok)) {
            throw new Error(getStringObject(data.data));
        }
        if (data.data && data.data.is_ok) {
            commit('makeOrderOperate', data.data.is_ok);
        } else {
            throw new Error(getStringObject(data.data));
        }
    },
    CHANGE_MAKE_ORDER_STATE({commit}, state) {
        commit('changeMakeOrderState', state)
    },
    async DELIVERY_LOCATIONS({commit}, params) {
        const requests = [];
        requests.push(
            {
                requestName: 'deliveryLocations',
                url: '/internal/delivery/{deliveryId}/locations',
                paramsUrl:
                    {
                        deliveryId: params.deliveryId
                    },
                method: 'GET',
                body: null,
            },
            {
                requestName: 'deliveryLocationsSelectId',
                url: '/internal/delivery/{deliveryId}/locations/id/select',
                paramsUrl:
                    {
                        deliveryId: params.deliveryId
                    },
                method: 'GET',
                body: null,
            },
        )

        const requestsPromises = new PromiseWorker($api, requests, EventBus);
        try {
            const results = await requestsPromises.executeAsyncRequests();
            params.results = results;
            const errorsList = requestsPromises.getErrorsResponses(results);
            if (errorsList.length > 0) {
                errorOutput(__t('O.FAILED_GET_DELIVERY_LOCATIONS'), JSON.stringify(errorsList), params.actionName);
            }
            commit('deliveryLocations', params);
        } catch (err) {
            errorOutput(__t('O.FAILED_GET_DELIVERY_LOCATIONS'), err, params.actionName);
        }
    },
    GET_DATA_ACTIVE_LOCATIONS_ID({commit}, params) {
        $api.get('/internal/delivery/' + params.deliveryId + '/locations/id/select')
            .then(resp => {
                if (resp.data) {
                    commit('getDataActiveLocationsId', resp.data);
                } else {
                    errorOutput(__t('O.FAILED_GET_INFORMATION_ON_ACTIVE_LOCATIONS'), resp, params.actionName);
                }
            })
            .catch(err => {
                errorOutput(__t('O.FAILED_GET_INFORMATION_ON_ACTIVE_LOCATIONS'), err, params.actionName);
            })
    },
    ADD_ACTIVE_LOCATION({commit}, params) {
        $api.put('/internal/delivery/' + params.groupId + '/location/' + params.locationId + '/select',
            params.data)
            .then(resp => {
                if (resp.status && resp.status === 200) {
                    commit('addActiveLocation');
                }
            })
            .catch(err => {
                errorOutput(__t('O.FAILED_ADD_LOCATION_ACTIVE'), err, params.actionName);
            })
    },
    REMOVE_ACTIVE_LOCATION({commit}, params) {
        $api.delete('/internal/delivery/' + params.groupId + '/location/' + params.locationId + '/select')
            .then(resp => {
                if (resp.status && resp.status === 200) {
                    commit('removeActiveLocation', params);
                }
            })
            .catch(err => {
                errorOutput(__t('O.FAILED_REMOVE_LOCATION_INACTIVE'), err, params.actionName);
            })
    },
    async ADD_ACTIVE_LOCATION_LIST({commit}, params) {
        const requests = [];
        requests.push(
            {
                requestName: 'Add active location',
                url: '/internal/delivery/{deliveryId}/locations/id/select/list',
                paramsUrl:
                    {
                        deliveryId: params.id
                    },
                method: 'PUT',
                body: params.restList,
            })

        const requestsPromises = new PromiseWorker($api, requests, EventBus);
        try {
            const results = await requestsPromises.executeAsyncRequests();
            const errorsList = requestsPromises.getErrorsResponses(results);
            commit('addActiveLocationList', {results: results, errorsList: errorsList, actionName: params.actionName});
        } catch (err) {
            errorOutput(__t('O.FAILED_ADD_LOCATION_LIST_INACTIVE'), err, params.actionName);
        }
    },
    async REMOVE_ACTIVE_LOCATION_LIST({commit}, params) {
        const requests = [];
        requests.push(
            {
                requestName: 'Remove active location',
                url: '/internal/delivery/{deliveryId}/locations/id/select/list',
                paramsUrl:
                    {
                        deliveryId: params.id
                    },
                method: 'DELETE',
                body: params.restList,
            })

        const requestsPromises = new PromiseWorker($api, requests, EventBus);
        try {
            const results = await requestsPromises.executeAsyncRequests();
            const errorsList = requestsPromises.getErrorsResponses(results);
            commit('removeActiveLocationList', {
                results: results,
                errorsList: errorsList,
                actionName: params.actionName
            });
        } catch (err) {
            errorOutput(__t('O.FAILED_REMOVE_LOCATION_LIST_INACTIVE'), err, params.actionName);
        }
    },
    async ORDERS_POOLING_DELIVERY({commit}, params) {
        const requests = [];
        requests.push(
            {
                requestName: 'ordersPoolingDelivery',
                url: '/internal/delivery/order/pooling',
                paramsUrl:
                    {},
                method: 'GET',
                body: null,
            })

        const requestsPromises = new PromiseWorker($api, requests, EventBus);
        try {
            const results = await requestsPromises.executeAsyncRequests();
            const errorsList = requestsPromises.getErrorsResponses(results);
            commit('ordersPoolingDelivery', {
                results: results,
                errorsList: errorsList,
                actionName: params.actionName
            });
        } catch (err) {
            errorOutput(__t('O.FAILED_REQUEST_ORDERS_POOLING_DELIVERY'), err, params.actionName);
            console.log(err);
            $store.dispatch('couriers/STATE_LOAD_ORDERS_POOLING_DELIVERY', false);
        }
    },
    async ORDER_DELIVERY_INFO({commit}, params) {
        $store.dispatch('couriers/STATE_LOAD_ORDER_DELIVERY_INFO', true);
        const requests = [];
        requests.push(
            {
                requestName: 'orderInfo',
                url: '/internal/delivery/order/{id}/build',
                paramsUrl:
                    {id: params.idOrder},
                method: 'GET',
                body: null,
            })
        requests.push(
            {
                requestName: 'orderStatus',
                url: '/internal/delivery/order/{id}/status',
                paramsUrl:
                    {id: params.idOrder},
                method: 'GET',
                body: null,
            })

        const requestsPromises = new PromiseWorker($api, requests, EventBus);
        try {
            const results = await requestsPromises.executeAsyncRequests();
            const errorsList = requestsPromises.getErrorsResponses(results);
            commit('orderDeliveryInfo', {
                results: results,
                errorsList: errorsList,
                actionName: params.actionName
            });
        } catch (err) {
            errorOutput(__t('O.FAILED_REQUEST_ORDER_DELIVERY_INFO'), err, params.actionName);
            $store.dispatch('couriers/STATE_LOAD_ORDER_DELIVERY_INFO', true);
        }
    },
    STATE_LOAD_ORDER_DELIVERY_INFO({commit}, stateLoad) {
        commit('stateLoadOrderDeliveryInfo', stateLoad)
    },
    async LOGS_DELIVERY_INFO({commit}, params) {
        $store.dispatch('couriers/STATE_LOAD_LOGS_DELIVERY_INFO', true);
        const requests = [];
        requests.push(
            {
                requestName: 'orderInfo',
                url: '/internal/delivery/order/{id}/logs',
                paramsUrl:
                    {id: params.idOrder},
                method: 'GET',
                body: null,
            })

        const requestsPromises = new PromiseWorker($api, requests, EventBus);
        try {
            const results = await requestsPromises.executeAsyncRequests();
            const errorsList = requestsPromises.getErrorsResponses(results);
            commit('logsDeliveryInfo', {
                results: results,
                errorsList: errorsList,
                actionName: params.actionName
            });
        } catch (err) {
            errorOutput(__t('O.FAILED_REQUEST_LOGS_DELIVERY_INFO'), err, params.actionName);
            $store.dispatch('couriers/STATE_LOAD_LOGS_DELIVERY_INFO', false);
        }
    },
    STATE_LOAD_LOGS_DELIVERY_INFO({commit}, stateLoad) {
        commit('stateLoadLogsDeliveryInfo', stateLoad);
    },
    STATE_CANCEL_ACTIVE_ORDER({commit}, stateCancel) {
        commit('stateCancelActiveOrder', stateCancel)
    },
    async CANCEL_ACTIVE_ORDER({commit}, params) {
        $store.dispatch('couriers/STATE_CANCEL_ACTIVE_ORDER', true);
        const requests = [];
        requests.push(
            {
                requestName: 'cancelOrder',
                url: '/internal/delivery/order/{id}/status/{state}',
                paramsUrl:
                    {
                        id: params.idOrder,
                        state: params.state,
                    },
                method: 'PATCH',
                body: null,
            })

        const requestsPromises = new PromiseWorker($api, requests, EventBus);
        try {
            const results = await requestsPromises.executeAsyncRequests();
            const errorsList = requestsPromises.getErrorsResponses(results);
            commit('cancelActiveOrder', {
                results: results,
                errorsList: errorsList,
                actionName: params.actionName
            });
        } catch (err) {
            errorOutput(__t('O.FAILED_REQUEST_CANCEL_ACTIVE_ORDER'), err, params.actionName);
            $store.dispatch('couriers/STATE_CANCEL_ACTIVE_ORDER', false);
        }
    },
    SET_ACTIVE_ITEM_LIST_GROUPS({commit}, itemGroups) {
        commit('setActiveItemListGroups', itemGroups);
    },
    async ORDERS_POS({commit}, params) {
        const requests = [];
        requests.push(
            {
                requestName: 'ordersPos.data',
                url: '/internal/delivery/pos/orders',
                paramsUrl: {},
                method: 'GET',
                body: null,
            },
        )

        const props = {
            commit: commit,
            commitName: 'setOrdersPos',
            nameError: 'O.FAILED_TO_GET_LIST_RESTAURANTS_LOCATIONS',
            requests: requests,
            showError: true,
        }
        await executePromises(state, params, props);
    },
    SET_STATES_LOADING_LIST({commit}, params) {
        commit('setStatesLoadingList', params);
    },
    SELECT_LOCATION_COURIER_NEW_MENU({commit}, location){
        commit('setSelectLocationCourier', location);
    }
}

const mutations = {
    updateCouriersField,
    fetchOrderRestLocations(state, params){

        if(state.orderRestLocations && Array.isArray(state.orderRestLocations)
            && state.orderRestLocations.length > 0){
            // console.log(state.orderRestLocations[0]);
            // console.log(params.results[0].result.data[0]);
            state.selectLocationCourier = state.orderRestLocations[0];
            if(state.selectLocationCourier.id) {
                $store.dispatch('couriers/SELECT_LOCATION_COURIER_NEW_REGISTRATION', state.selectLocationCourier);
            }
        }
        EventBus.$emit('fetch_order_rest_locations', state.orderRestLocations);
        setStatesLoadingList(state, params);

    },
    setSelectLocationCourier(state, location){
        state.selectLocationCourier = location;
        $store.dispatch('couriers/SELECT_LOCATION_COURIER_NEW_REGISTRATION', state.selectLocationCourier);
    },
    setStatesLoadingList(state,params){
        setStatesLoadingList(state, params);
    },
    setOrdersPos(state, params){

        if(state.ordersPos && state.ordersPos.data
            && Array.isArray(state.ordersPos.data) && state.ordersPos.data.length > 0){
            state.ordersPos.activeItem = state.ordersPos.data[0];
        }
        if(params.eventsList && Array.isArray(params.eventsList)){
            sendEventsList(params.eventsList);
        }

        setStatesLoadingList(state, params);
    },
    setActiveItemListGroups(state, itemGroup) {
        state.activeItemListGroups = itemGroup;
    },
    stateCancelActiveOrder(state, stateCancel) {
        state.stateCancelActiveOrder = stateCancel;
    },
    cancelActiveOrder(state, params) {
        if (params.errorsList.length > 0) {
            errorOutput(__t('O.ERROR_CANCEL_ACTIVE_ORDER'), params.errorsList, params.actionName);
        }
        params.results.forEach(item => {
            if (item.result.data && item.result.data.status === 'operation_success') {
                toast.success(__t('O.ORDER_CANCEL_SUCCESSFULLY'));
                state.activeCourierOrder = null;
            } else {
                errorOutput(__t('O.FAILED_CANCEL_ACTIVE_ORDER'), '', params.actionName);
            }
        })
        $store.dispatch('couriers/ORDERS_POOLING_DELIVERY', {actionName: 'ordersPoolingDelivery'});
        $store.dispatch('couriers/STATE_CANCEL_ACTIVE_ORDER', false);
    },
    stateLoadLocationsDelivery(state, stateLoad) {
        state.isLoadLocationsDelivery = stateLoad;
    },
    setActiveAggregator(state, activeAggregator) {
        state.activeAggregator = activeAggregator;
    },
    orderInfoByLocationLoading(state, stateLoad) {
        state.orderInfoByLocation.loading = stateLoad;
    },
    searchOrderLoading(state, stateLoad) {
        state.search_order.loading = stateLoad;
    },

    searchComplete(state, res) {
        state.search_order = {...state.search_order, ...res}

        if(state.search_order.delivery_locations && Array.isArray(state.search_order.delivery_locations)
        && state.search_order.delivery_locations.length > 0){
            state.selectLocationCourier = state.search_order.delivery_locations[0];
            if(state.selectLocationCourier.id) {
                $store.dispatch('couriers/SELECT_LOCATION_COURIER_NEW_REGISTRATION', state.selectLocationCourier);
            }
        }

        $store.dispatch('couriers/ORDER_SEARCH_STATE', false);
    },

    getCountAllCouriers(state) {
        state.countAllCouriers = 0;
        if (state.couriersOrdersPooling.couriersNewList && Array.isArray(state.couriersOrdersPooling.couriersNewList)) {
            state.countAllCouriers += state.couriersOrdersPooling.couriersNewList.length;
        }
        if (state.couriersOrdersPooling.couriersInProgressList && Array.isArray(state.couriersOrdersPooling.couriersInProgressList)) {
            state.countAllCouriers += state.couriersOrdersPooling.couriersInProgressList.length;
        }
        if (state.couriersOrdersPooling.couriersReadyList && Array.isArray(state.couriersOrdersPooling.couriersReadyList)) {
            state.countAllCouriers += state.couriersOrdersPooling.couriersReadyList.length;
        }
    },

    clickItemMenuCouriers(state, itemMenu) {
        state.activeCourierOrder = itemMenu;
        if (state.activeCourierOrder && state.activeCourierOrder.id) {
            $store.dispatch('couriers/ORDER_DELIVERY_INFO', {
                idOrder: state.activeCourierOrder.id,
                actionName: 'orderDeliveryInfo'
            });
            $store.dispatch('couriers/LOGS_DELIVERY_INFO', {
                idOrder: state.activeCourierOrder.id,
                actionName: 'logsDeliveryInfo'
            });
        }
        EventBus.$emit('click_item_menu_couriers');
    },
    clickItemMenuCouriersPos(state, itemMenu) {
        state.activeCourierOrder = itemMenu;
        if(state.activeCourierOrder && state.activeCourierOrder.uniq_id) {
            $store.dispatch('couriers/SET_STATES_LOADING_LIST',{
                statesLoading: ['search_order.loading'],
                stateLoad: true,
            });

            $store.dispatch('couriers/FILL_ORDER_ID', state.activeCourierOrder.uniq_id)
            $store.dispatch('couriers/FETCH_ORDER_REST_LOCATIONS', {
                statesLoading: ['search_order.loading'],
                stateLoad: false,
                order_uniq_id: state.activeCourierOrder.uniq_id
            });
        }

        // if(state.activeCourierOrder && state.activeCourierOrder.uniq_id) {
        //     $store.dispatch('couriers/FETCH_ORDER_REST_LOCATIONS', state.activeCourierOrder.uniq_id);
        // }
    },
    orderDeliveryInfo(state, params) {
        params.results.forEach(res => {
            if (res.error) {
                return;
            }
            if (res.result && res.requestName === 'orderInfo' && res.result.data && res.result.status === 'operation_success') {
                state.activeCourierOrderInfo.order = res.result.data;
            }
            if (res.result && res.requestName === 'orderStatus' && res.result.data && res.result.status === 'operation_success') {
                if (res.result.data.order && res.result.data.order.status) {
                    state.activeCourierOrderInfo.status = res.result.data.order.status;
                }
            }
        })
        if (params.errorsList.length > 0) {
            errorOutput(__t('O.ERROR_ORDER_DELIVERY_INFO'), params.errorsList, params.actionName);
        }
        $store.dispatch('couriers/STATE_LOAD_ORDER_DELIVERY_INFO', false);
    },
    logsDeliveryInfo(state, params) {
        params.results.forEach(res => {
            if (res.error) {
                return;
            }
            if (res.result && res.result.data && res.result.status === 'operation_success') {
                state.activeCourierOrderInfo.logs = res.result.data;
            }
        })
        if (params.errorsList.length > 0) {
            errorOutput(__t('O.ERROR_LOGS_DELIVERY_INFO'), params.errorsList, params.actionName);
        }
        $store.dispatch('couriers/STATE_LOAD_LOGS_DELIVERY_INFO', false);
    },

    stateLoadOrderDeliveryInfo(state, stateLoad) {
        state.activeCourierOrderInfo.loadingInfo = stateLoad;
        if (!stateLoad) {
            EventBus.$emit('load_order_delivery_info');
        }
    },
    stateLoadLogsDeliveryInfo(state, stateLoad) {
        state.activeCourierOrderInfo.loadingLogs = stateLoad;
    },
    changeStateNewCourier(state, stateCourier) {
        state.isNewCourier = stateCourier;
    },
    setLoadOrdersPoolingDelivery(state, stateLoad) {
        state.couriersOrdersPooling.loading = stateLoad;
    },
    setLoadCourierStatus(state, stateLoad) {
        state.isLoadCourierStatus = stateLoad;
    },
    loadStatusCourier(state) {
        state.isLoadCourierStatus = true;
        setTimeout(() => state.isLoadCourierStatus = false, 1000);
    },

    setIsSelectCourierItem(state, stateSelect) {
        state.isSelectCourierItem = stateSelect;
    },
    selectLocationCourierNewRegistration(state, params) {
        if (params.location) {
            state.selectLocationCourierNew = location;
        }
    },
    fillOrderId(state, uniq_id) {
        state.search_order.uniq_id = parseInt(uniq_id);
    },
    setOrderInfoSelectLocation(state, location) {
        state.orderInfoByLocation.selectLocation = location;
    },
    getOrderInfoComplete(state, resp) {
        state.orderInfoByLocation.order = resp;

        if (state.orderInfoByLocation.order && !state.orderInfoByLocation.order.is_exist) {
            EventBus.$emit('order_not_found');
            $store.dispatch('couriers/ORDER_INFO_BY_LOCATION_STATE', false);
            return;
        }
        $store.dispatch('couriers/ORDER_INFO_BY_LOCATION_STATE', false);
        EventBus.$emit('get_order_by_location');
    },
    changeMakeOrderState(state, makeState) {
        state.makeOrderInfo.loading = makeState;
    },
    makeOrderOperate(state, status) {
        state.makeOrderInfo.is_ok = status;
        $store.dispatch('couriers/CHANGE_MAKE_ORDER_STATE', false);
        EventBus.$emit('make_order_loading');
    },

    deliveryLocations(state, params) {
        state.deliveryLocations = [];
        params.results.forEach(res => {
            if (res.error) {
                return;
            }
            if (res.requestName === 'deliveryLocations') {
                if (res.result && res.result.data) {
                    state.deliveryLocations = res.result.data;
                }
            } else if (res.requestName === 'deliveryLocationsSelectId') {
                if (res.result && res.result.data) {
                    state.activeDeliveryLocationsId = res.result.data;
                }
            }
        })
        mutations.changeStateActiveLocations(state);
        if (params.errorsList) {
            errorOutput(__t('O.ERROR_GET_DELIVERY_LOCATIONS_LIST'), params.errorsList, params.actionName);
        }
        EventBus.$emit('load_delivery_locations');
    },
    changeStateActiveLocations(state) {
        if (Array.isArray(state.activeDeliveryLocationsId)) {
            state.deliveryLocations.forEach(item => {
                item.isSelect = state.activeDeliveryLocationsId.includes(item.id);
            })
        }
    },
    addActiveLocation(state) {
        EventBus.emit('change_active_delivery_location');
    },
    removeActiveLocation(state, params) {
        if (params.onlySelectLocations) {
            let index = state.deliveryLocations.findIndex(item => item.id === params.locationId);
            state.deliveryLocations.splice(index, 1);
        }
        EventBus.emit('change_active_delivery_location');
    },
    addActiveLocationList(state, params) {
        if (params.errorsList.length !== 0) {
            errorOutput(__t('O.OPERATION_NOT_COMPLETED'), JSON.stringify(params.errorsList), params.actionName);
        }
        EventBus.emit('change_active_delivery_location');
    },
    removeActiveLocationList(state, params) {
        if (params.errorsList.length !== 0) {
            errorOutput(__t('O.OPERATION_NOT_COMPLETED'), JSON.stringify(params.errorsList), params.actionName);
        }
        EventBus.emit('change_active_delivery_location');
    },
    getDataActiveLocationsId(state, resp) {
        if (resp.status === 'operation_success') {
            state.activeDeliveryLocationsId = resp.data;
            mutations.changeStateActiveLocations(state);
        }
    },

    fillOrdersDelivery(state, res) {
        if (res.new && Array.isArray(res.new)) {
            state.couriersOrdersPooling.couriersNewList = res.new;
            state.couriersOrdersPooling.couriersNewList.forEach(item => item.typeCourier = 'new');
        }
        if (res.in_progress && Array.isArray(res.in_progress)) {
            state.couriersOrdersPooling.couriersInProgressList = res.in_progress;
            state.couriersOrdersPooling.couriersInProgressList.forEach(item => item.typeCourier = 'inProgress');
        }
        if (res.ready && Array.isArray(res.ready)) {
            state.couriersOrdersPooling.couriersReadyList = res.ready;
            state.couriersOrdersPooling.couriersInProgressList.forEach(item => item.typeCourier = 'ready');
        }
        $store.dispatch('couriers/GET_COUNT_ALL_COURIERS');
        if (state.activeCourierOrder === null) {
            if (state.couriersOrdersPooling.couriersNewList.length !== 0) {
                $store.dispatch('couriers/CLICK_ITEM_MENU_COURIERS', state.couriersOrdersPooling.couriersNewList[0]);
            } else if (state.couriersOrdersPooling.couriersInProgressList.length !== 0) {
                $store.dispatch('couriers/CLICK_ITEM_MENU_COURIERS', state.couriersOrdersPooling.couriersInProgressList[0]);
            } else if (state.couriersOrdersPooling.couriersReadyList.length !== 0) {
                $store.dispatch('couriers/CLICK_ITEM_MENU_COURIERS', state.couriersOrdersPooling.couriersReadyList[0]);
            }
        }
    },
    ordersPoolingDelivery(state, params) {
        params.results.forEach(res => {
            if (res.error) {
                return;
            }
            if (res.result && res.result.data && res.result.status === 'operation_success') {
                mutations.fillOrdersDelivery(state, res.result.data);
            }
        })
        if (params.errorsList.length > 0) {
            errorOutput(__t('O.ERROR_ORDERS_POOLING_DELIVERY'), params.errorsList, params.actionName);
        }
        $store.dispatch('couriers/STATE_LOAD_ORDERS_POOLING_DELIVERY', false);
    },
}

const getters = {
    getCouriersField,
    getActiveItemListGroups(state) {
        return state.activeItemListGroups;
    },
    getIsLoadLocationsDelivery(state) {
        return state.isLoadLocationsDelivery;
    },
    getCountAllCouriers(state) {
        return state.countAllCouriers;
    },
    getActiveCourierOrder(state) {
        return state.activeCourierOrder;
    },
    getIsNewCourier(state) {
        return state.isNewCourier;
    },
    getIsLoadCourierStatus(state) {
        return state.isLoadCourierStatus;
    },
    getIsSelectCourierItem(state) {
        return state.isSelectCourierItem;
    },
    getOrderInfoByLocation(state) {
        return state.orderInfoByLocation;
    },
    getDeliveryLocations(state) {
        return state.deliveryLocations;
    },
    getActiveDeliveryLocationsId(state) {
        return state.activeDeliveryLocationsId;
    },
    getСouriersOrdersPooling(state) {
        return state.couriersOrdersPooling;
    },
    getActiveCourierOrderInfo(state) {
        return state.activeCourierOrderInfo;
    },
    getStateCancelActiveOrder(state) {
        return state.stateCancelActiveOrder;
    },
    getActiveAggregator(state) {
        return state.activeAggregator;
    },
    getOrdersPos(state) {
        return state.ordersPos;
    },
    getSelectLocationCourier(state) {
        return state.selectLocationCourier;
    },
    getOrderRestLocations(state) {
        return state.orderRestLocations;
    }
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}

const getStringObject = (err) => {
    if (err && typeof err === 'object' && !Array.isArray(err)) {
        return JSON.stringify(err);
    }
    return err;
}
